import { Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "../../style/CardOrderDetail.css";
import "../SingleProduct.css";
import CartItems from "./CartItems";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { addComasToPrice } from "../../utils/PriceFormat";
import axios from "axios";
import { useState } from "react";
import { getShoppingCart } from "../../state/shoppingCart";
import { getItemCart } from "../../state/itemCart";

const CartDetailsHeader = () => {
  const [updatingCart, setUpdatingCart] = useState(false);
  const [loadingBuy, setLoadingBuy] = useState(false);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const shoppingCart = useSelector((state) => state.shoppingCart);
  const user = useSelector((state) => state.user);
  const cartItems = useSelector((state) => state.itemCarts);

  const handleCheckout = () => {
    navigate(`/checkout`);
  }

  const handleOnBuy = () => {
    let orderId;
    setLoadingBuy(true);
    axios
      .post(
        `https://the-green-shop.herokuapp.com/api/orderDetail/createOrderDetail`,
        {
          UserId: user.id,
          total: shoppingCart.total,
        }
      )
      .then((order) => {
        orderId = order.data.id;
        return Promise.all(
          cartItems.map((item) => {
            axios.post(
              `https://the-green-shop.herokuapp.com/api/orderItem/add`,
              {
                price: item.product.price,
                quantity: item.quantity,
                productId: item.productId,
                orderdetailId: order.data.id,
              }
            );
          })
        );
      })
      .then(() => {
        return Promise.all(
          cartItems.map((item) => {
            axios.delete(
              `https://the-green-shop.herokuapp.com/api/itemCart/remove/${item.id}`
            );
          })
        );
      })
      .then(() => {
        return axios.delete(
          `https://the-green-shop.herokuapp.com/api/shoppingCart/${shoppingCart.id}`
        );
      })
      .then(() => {
        return dispatch(getShoppingCart());
      })
      .then(({ payload }) => {
        dispatch(getItemCart(payload.id));
      })
      .then(() => {
        setLoadingBuy(false);
        navigate(`/orderDetails/${orderId}`);
      });
  };


  return shoppingCart.id ? (
    <div className="orderContainer2">
      <div className="cart-title">
        <span
          className=""
          style={{ fontSize: "1.4em", fontWeight: "500", marginBottom: "10px" }}
        >
          ShoppingCart
        </span>
        <Link to="/products/all" style={{ textDecoration: "none" }}>
          <Button
            style={{ display: "flex", alignItems: "center", margin: 0 }}
            variant="outline-primary"
          >
            <HiArrowNarrowLeft style={{ marginRight: "10px" }} />
            Continue Shopping
          </Button>
        </Link>
      </div>
      <CartItems
        updatingCart={updatingCart}
        setUpdatingCart={setUpdatingCart}
      />
      <div style={{ alignSelf: "flex-end" }}>
        Total:{" "}
        <span style={{ fontSize: "1.2em" }}>
          {updatingCart && (
            <Spinner
              animation="border"
              color="white"
              style={{ width: "1.2em", height: "1.2em" }}
            />
          )}
          {!updatingCart && <>{"$ " + addComasToPrice(shoppingCart.total)}</>}
        </span>
      </div>
      <Button
        variant="success"
        onClick={handleCheckout}
        style={{
          width: "120px",
          alignSelf: "flex-end",
          margin: 0,
          marginTop: "10px",
        }}
      >
        {loadingBuy && (
          <Spinner
            animation="border"
            color="white"
            style={{ width: "1.2em", height: "1.2em", fontWeight: "normal" }}
          />
        )}
        {!loadingBuy && "Checkout"}
      </Button>
    </div>
  ) : null;
};

export default CartDetailsHeader;
